import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        paddingLeft: '12px',
        borderLeft: '4px solid',
    },
    positive_border: {
        borderLeftColor: theme.palette.success.main
    },
    negative_border: {
        borderLeftColor: theme.palette.error.main
    },
    header: {
        fontSize: '13px',
        fontWeight: 600,
        color: theme.palette.grey[700],
        marginBottom: '4px'
    },
    label: {
        fontSize: '12px',
        marginTop: '4px',
        color: theme.palette.grey[600],
        fontWeight: 500
    }
}));

export {useStyles}
